export const discountTypeValues = {
  fixed: 'fixed',
  percentage: 'percentage',
}

export const discountTypeOptions = [
  { value: discountTypeValues.fixed, labelKey: 'Importe fijo' },
  { value: discountTypeValues.percentage, labelKey: 'Porcentaje' },
]

export const bonusAppliesToValues = {
  exchangeOrder: 'exchange_order',
  newRequestedProducts: 'new_requested_products',
}

export const bonusAppliesToOptions = [
  { value: bonusAppliesToValues.exchangeOrder, labelKey: 'Pedido de cambio' },
  { value: bonusAppliesToValues.newRequestedProducts, labelKey: 'Nuevos productos solicitados' },
]
